import MiSelect from './MiSelect.vue'

export default MiSelect
